import { useCookieConsent, Locale } from '@taxfix/scouts-helpers'
import { CookieConsentOverlay } from '@taxfix/scouts-ui'

import cookieImage from '@/assets/images/icon-cookie.png'

export const CookieConsent = () => {
    const { isVisible, acceptCookies, rejectCookies, openPreferences } = useCookieConsent()

    if (isVisible)
        return (
            <CookieConsentOverlay
                locale={Locale.GB}
                imageSrc={cookieImage}
                onAccept={acceptCookies}
                onReject={rejectCookies}
                onOpenPreferences={openPreferences}
            />
        )

    return null
}
